import { useDropzone } from "react-dropzone";

import Toast from "services/Toast";

export const StyledDropzone = (props) => {
    const baseStyle = {
        cursor: "pointer",
        borderWidth: 2,
        borderRadius: 2,
        borderColor: "#eeeeee",
        borderStyle: "dashed",
        outline: "none",
        position: "absolute",
    };

    const activeStyle = {
        borderColor: "#2196f3",
    };

    const acceptStyle = {
        borderColor: "#00e676",
    };

    const rejectStyle = {
        borderColor: "#ff1744",
    };

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        accept: "image/*",
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length === 0) {
                Toast.error("File type not valid");
                return;
            }
            props.onFileSelected(acceptedFiles[0]);
        },
    });

    const style = {
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
    };

    return (
        <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <img
                src={props.image}
                alt={""}
                className="thumb"
                style={{
                    maxWidth: "100px",
                    maxHeight: "100px",
                }}
                onError={(e) => {
                    e.target.className += " failed";
                    e.target.src =
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
                }}
            />
        </div>
    );
};
